import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const patient = {
  path: '/orders',
  component: Layout,
  name: 'orders',
  redirect: '/orders/index',
  children: [
    {
      path: '/orders/index',
      component: () => import('@/views/orders/index'),
      name: 'orders.index',
      meta: { title: i18n.t(`message.orders`)}
    },
  ]
}

export default patient